import { FieldErrorMessage } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/FormControlErrorMessage";
import { ComponentProps } from "react";
import { FieldError, FieldErrors, FieldValues } from "react-hook-form";
import { getFieldFromNestedObject } from "shared/utils/objectUtils";

export const RenderErrorInPath = ({
  errors,
  errorPath,
  ...rest
}: {
  errors?: FieldErrors<FieldValues>;
  errorPath: string;
} & Omit<ComponentProps<typeof FieldErrorMessage>, "field">) => {
  const field = getFieldFromNestedObject<FieldError>(errors, errorPath);
  if (!field) {
    return null;
  }

  return <FieldErrorMessage {...rest} field={field} />;
};
